import { render, staticRenderFns } from "./ManagementAndAdministrationPanel.vue?vue&type=template&id=645ed81c&scoped=true&"
import script from "./ManagementAndAdministrationPanel.vue?vue&type=script&lang=ts&"
export * from "./ManagementAndAdministrationPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ed81c",
  null
  
)

export default component.exports